import { SuportAreaTranslations } from "./suport-area-pt-br";

export const SUPORT_AREA_ES_ES: SuportAreaTranslations = {
	title: "Centro de ayuda",
	questionTitle: "¿Necesitas ayuda?",
	questionDescription:
		"Abre un nuevo ticket o haz seguimiento a los que ya están en curso con nuestro equipo.",
	openTicket: "Hablar con un agente",
	close: "Cerrar",
};
